<div class="login-page">
  <div class="content">
    <!-- <h1 class="app-name">Sb Admin Material</h1> -->
    <form class="login-form" fxFlex fxLayout="column" (ngSubmit)="submit()" [formGroup]="resetpasswordForm" novalidate>
      <div class="text-center">
        <h2 class="app-name">
          <img src="assets/images/logo.svg" />
        </h2>
      </div>
      <div fxFlex fxlayout="row" fxlayout.lt-md="column">
        <div fxFlexFill class="mb40">
          <mat-form-field class="w-100" appearance="outline" [hideRequiredMarker]="true">
            <mat-label>{{ 'common.email' | translate }}</mat-label>
            <input matInput type="text" formControlName="email" autocomplete="email" required />
            <!--            <mat-hint class="email-hint">{{ 'auth.reset-password.email.hint' | translate }}</mat-hint>-->
            <mat-error *ngIf="resetpasswordForm.controls.email.invalid && resetpasswordForm.controls.email.touched">
              <span translate>{{ 'auth.reset-password.email.required' | translate }}</span>
            </mat-error>
          </mat-form-field>
          <p class="email-hint">{{ 'auth.reset-password.email.hint' | translate }}</p>
        </div>
      </div>

      <div fxFlex fxlayout="row" fxlayout.lt-md="column">
        <div fxFlexFill class="mb40">
          <div class="login-error" [hidden]="!error || isLoading" translate>
            {{ error }}
          </div>
        </div>
      </div>
      <div fxFlex fxlayout="row" fxlayout.lt-md="column">
        <div fxFlexFill class="text-center">
          <button
            mat-flat-button
            [class.white-color]="showSuccessMgs"
            color="primary"
            class="block-level"
            type="submit"
            [disabled]="resetpasswordForm.invalid || isLoading"
          >
            <app-loader class="inline-loader" [isLoading]="isLoading"></app-loader>
            <mat-icon *ngIf="showSuccessMgs">check_circle</mat-icon>
            <span>
              {{ (showSuccessMgs ? 'auth.reset-password.done' : 'auth.reset-password.submit') | translate }}
            </span>
          </button>
        </div>
      </div>
      <div fxFlex fxlayout="row" fxlayout.lt-md="column">
        <div fxFlexFill class="">
          <div fxFlex="100%" class="secondary-font">
            <a class="underline-none inline-flex mt20" [routerLink]="['/login']" translate>
              <span>{{ 'auth.login.title' | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
